export default __webpack_public_path__ + "static/media/switch.659e80a3.png";